module.exports = __webpack_public_path__ + "8a5356e9/img/mini-logo.18817ee5.svg";